












import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Modal from "../../shared/modal/Modal.vue";
import { ShipmentDTO } from "../../../model/data.model";

@Component({
  components: {
    Modal: Modal
  }
})
export default class ConfirmShipment extends Vue {
  @Prop() shipment: ShipmentDTO;
}
